import { render, staticRenderFns } from "./DetailV2.vue?vue&type=template&id=3ef320ee&scoped=true"
import script from "./DetailV2.vue?vue&type=script&lang=js"
export * from "./DetailV2.vue?vue&type=script&lang=js"
import style0 from "./DetailV2.vue?vue&type=style&index=0&id=3ef320ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef320ee",
  null
  
)

export default component.exports